import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

export const useStickersAnalytics = () => {
  const trackClickOnAssetTab = useCallback(({ info }: { info: string }) => {
    TrackingApi.trackClick({
      info,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackClickOnLoadPhoto = useCallback(() => {
    TrackingApi.trackClick({
      info: 'message_image_input',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackShowStickerPopup = useCallback(
    ({ info, order_id }: { info: string; order_id?: string | null }) => {
      TrackingApi.trackPopup({
        info,
        operation: 'show',
        parameter: order_id || undefined,
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  const trackCloseStickerPopup = useCallback(({ info }: { info: string }) => {
    TrackingApi.trackPopup({
      info,
      operation: 'close',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackClickStickerPopup = useCallback(({ info }: { info: string }) => {
    TrackingApi.trackPopup({
      info,
      operation: 'click',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackClickOnAssetTab,
    trackClickOnLoadPhoto,
    trackShowStickerPopup,
    trackCloseStickerPopup,
    trackClickStickerPopup,
  };
};
